// Tri des bornes de caisse, partagé par le panneau « Contrôle du panier » de l'écran Caméras et la
// carte « Caméra par caisse » de la configuration caméras (`sort-kiosks.test.mjs`).

/** Ordre naturel des libellés : « Caisse 2 » avant « Caisse 10 », casse et accents ignorés. */
export const LABEL_COLLATOR = new Intl.Collator('fr', { numeric: true, sensitivity: 'base' })

/**
 * Tri naturel des bornes de caisse par libellé (« Caisse 2 » avant « Caisse 10 », casse et accents
 * ignorés), id en départage ; la liste reçue n'est pas modifiée.
 */
export const sortKiosksByLabel = <T extends { id: number; label: string }>(
  kiosks: readonly T[],
): T[] =>
  [...kiosks].sort(
    (left, right) => LABEL_COLLATOR.compare(left.label, right.label) || left.id - right.id,
  )
